"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaseActionsSchema = exports.CaseActions = void 0;
const zod_1 = require("zod");
/**
 * Enum representing all possible case action flags.
 *
 * - These string values are sent from the frontend to the backend
 *   (e.g. in PUT/PATCH requests for updating case state).
 *
 * - The backend also uses this enum in switch/case logic to determine
 *   which specific action to perform based on the incoming "action" field.
 *
 * Example usage:
 *   if (action === CaseActionsEnum.UPLOADED_HYPOTHESIS) { ... }
 *   switch (action) {
 *     case CaseActionsEnum.GATE_P1_DECISION_RECORDED:
 *       // update Gate P1 decision
 *       break;
 *   }
 */
var CaseActions;
(function (CaseActions) {
    // Gate C1
    CaseActions["GATE_C1_COMPLETED_PRIOR_ART_SEARCH"] = "gateC1HasCompletedPriorArtSearch";
    CaseActions["GATE_C1_UPLOADED_PRESENTATION"] = "gateC1HasUploadedPresentation";
    CaseActions["GATE_C1_COMPLETED_HYPOTHESIS"] = "gateC1HasCompletedHypothesis";
    CaseActions["GATE_C1_PRESENTED_TO_COMMITTEE"] = "gateC1HasPresentedToCommittee";
    CaseActions["GATE_C1_DECISION_RECORDED"] = "gateC1DecisionRecorded";
    // Gate SO1
    CaseActions["GATE_SO1_COMPLETED_ASSESSMENT"] = "gateSO1HasBeenCompleted";
    // License Track
    CaseActions["LICENSE_TRACK_UPLOADED_MARKETING"] = "licenseTrackHasUploadedMarketingMaterial";
    CaseActions["LICENSE_TRACK_PRIORITY_DATE"] = "licenseTrackPriorityDateSecured";
    // Gate P1–P3
    CaseActions["GATE_P1_DECISION_RECORDED"] = "gateP1DecisionRecorded";
    CaseActions["GATE_P2_PURSUED_PATENT_DECISION_RECORDED"] = "gateP2PursuePatentDecisionRecorded";
    CaseActions["GATE_P3_FILED_FOREIGN_STRATEGY"] = "gateP3HasFiledForeignPatentStrategy";
    // IP Protection
    CaseActions["IP_APPLIED_FOR_PROTECTION"] = "ipPriorityHasAppliedForIPProtection";
    // No Commercialisation
    CaseActions["NO_COMMERCIALISATION_NOTIFIED_SUBMITTER"] = "noCommercialisationHasNotifiedSubmitter";
    // Offers
    CaseActions["OFFER_TO_NIPMO_RECORDED"] = "nipmoOfferToNipmoDecisionRecorded";
    CaseActions["OFFER_TO_INVENTORS_RECORDED"] = "inventorsOfferToInventorDecisionRecorded";
    // National Phase Transitions
    CaseActions["NATIONAL_TRANSITION_TO_NIPMO"] = "nationalTransitionToNipmo";
    CaseActions["NATIONAL_ABANDON_PATENT"] = "nationalAbandonPatent";
    // Assessment Forms
    CaseActions["GATE_P1_ASSESSMENT_FORM_COMPLETED"] = "gateP1AssessmentFormCompleted";
    CaseActions["GATE_P2_ASSESSMENT_FORM_COMPLETED"] = "gateP2AssessmentFormCompleted";
    CaseActions["GATE_P3_ASSESSMENT_FORM_COMPLETED"] = "gateP3AssessmentFormCompleted";
})(CaseActions || (exports.CaseActions = CaseActions = {}));
/**
 * Zod schema for validating and parsing case action values.
 *
 * - Ensures that a given input is a valid CaseActions value.
 * - Can be used in request validation (e.g. with ZodValidationPipe in NestJS).
 *
 * Example:
 *   CaseActionsSchema.parse("gateC1HasUploadedPresentation"); // valid
 *   CaseActionsSchema.parse("invalidAction"); // will throw
 */
exports.CaseActionsSchema = zod_1.z.enum(Object.values(CaseActions));
